(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AssistantDialogController', AssistantDialogController);

    AssistantDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Assistant'];

    function AssistantDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Assistant) {
        var vm = this;

        vm.assistant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.sections = Assistant.sections();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.assistant.id !== null) {
                Assistant.update(vm.assistant, onSaveSuccess, onSaveError);
            } else {
                Assistant.save(vm.assistant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:assistantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
